<template>
    <div class="pop-get">
        <div class="pop-bg"></div>
        <div class="pop-get-content">
            <div class="pop-get-content-bg pop-gourd-grey">
                <div class="pop-text">
                    <p class="qm-special-font">仙缘未至，静心感悟。</p>
                    <p class="qm-special-font">明日此时，再叩剑心。</p>
                </div>
            </div>
            <div class="award-btn button-1 g-flex-center-center" @click="onClick">
                <p class="award-btn-text">我知道了</p>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useStore } from '@/store';
const store = useStore();
const onClick = () => {
    store.setPopStatus('noget', false);
};
</script>
<style lang="scss" scoped>
.pop-get {
    position: relative;
    width: 600px;
    margin: 0 auto;
    .pop-get-content {
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        &-bg {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
}
.pop-text p {
    font-size: 38px;
    line-height: 40px;
    color: #276ad1;
}
.title {
    position: relative;
    &-text {
        font-size: 48px;
        color: #276ad1;
        line-height: 50px;
        padding: 0 16px;
    }
    &-bg {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 4px;
        margin: auto;
    }
    &-right {
        transform: rotate(180deg);
    }
}

.award {
    &-btn {
        position: relative;
        z-index: 2;
        margin: 0 auto 0;

        &-text {
            font-weight: bold;
            font-size: 28px;
            color: #a9582f;
            line-height: 1;
        }
    }
}
</style>
